import { UserMenuData } from './types';

export const userMenuData: UserMenuData = {
  signOut: {
    text: 'menu_sign_out',
    name: 'sign_out',
    href: 'https://www.wix.com/signout',
  },
  mySites: {
    text: 'menu_my_sites',
    name: 'my_sites',
    href: 'https://www.wix.com/my-account',
  },
  userNav: [
    {
      text: 'menu_account_settings',
      name: 'account_settings',
      href: 'https://www.wix.com/account/account-settings',
    },
    {
      text: 'menu_billing_and_payments',
      name: 'billing',
      href: 'https://www.wix.com/wix/api/PaymentConsole',
    },
    {
      text: 'menu_vouchers',
      name: 'vouchers',
      href: 'https://www.wix.com/account/vouchers',
    },
  ],
};
